import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Menu } from "antd";

const TopMenuLgOffcanvas = ({ menus, show, onHideClick }) => {
  const [openKeys, setOpenKeys] = useState([]);
  const onOpenChange = (keys) => {
    /* const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }*/
  };

  const getSingleMenuLink = (items) => {
    return (
      <Link
        to={`/${items.menulink == "/" ? "" : items.menulink}`}
        onClick={(e) => onHideClick && onHideClick()}
      >
        {items.title}
      </Link>
    );
  };
  const getChildrens = (items) => {
    let rv = [];
    items.map((item, i) => {
      if (item.children && item.children.length > 0) {
        rv.push({
          key: item.id,
          icons: null,
          children: getChildrens(item.children),
          label: item.title,
        });
      } else {
        rv.push({
          label: getSingleMenuLink(item),
        });
      }
    });
    return rv;
  };

  const getMenuItems = () => {
    let rv = [];
    menus.map((items, i) => {
      if (items.children && items.children.length > 0) {
        rv.push({
          key: items.id,
          icons: null,
          children: getChildrens(items.children),
          label: items.title,
        });
      } else {
        rv.push({
          label: getSingleMenuLink(items),
        });
      }
    });
    return rv;
  };

  const handleClick = (e) => {};

  return (
    <>
      <Offcanvas
        show={show}
        onHide={onHideClick && onHideClick}
        placement="end"
      >
        <Offcanvas.Header className="border-bottom" closeButton>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Menu mode="inline" items={getMenuItems()} onClick={handleClick} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};
export default TopMenuLgOffcanvas;
